export default "__VITE_ASSET__C$ZutPsF__"